export default __webpack_public_path__ + "static/media/content.db2ec4cf.csv";